module.exports = __WEBPACK_EXTERNAL_MODULE_143__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/system/LoaderContext","root":["openfl","system","LoaderContext"],"commonjs":"openfl/system/LoaderContext","commonjs2":"openfl/system/LoaderContext"}
// module id = 143
// module chunks = 0